<template>
  <div class="c-item-list-heading">
    <span class="p-a01-heading">
      {{ title }}
    </span>
    <div v-if="localShowButton" class="c-item-list-heading__button_main">
      <ButtonMain tag="a" :href="lifeUrl" style="background: #089398">
        <span class="c-item-list-heading__button_main__label">
          {{ lifeText }}
        </span>
        <IconBase
          :width="24"
          :height="24"
          view-box="0 0 24 24"
        >
          <IconArrowRight />
        </IconBase>
      </ButtonMain>
      <ButtonMain tag="a" :href="goodsUrl" style="background: #F36D0D">
        <span class="c-item-list-heading__button_main__label">
          {{ goodsText }}
        </span>
        <IconBase
          :width="24"
          :height="24"
          view-box="0 0 24 24"
        >
          <IconArrowRight />
        </IconBase>
      </ButtonMain>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowRight from "@/common/components/icons/IconArrowRight.vue";
import CONST_DATA from "@/general/mixins/const/constData";
import auth from "@/general/store/modules/auth";
import globals from "@/general/store/modules/globals";

@Options({
  props: {
    title: { type: String, required: true },
    showButton: { type: Boolean, required: false, default: false }
  },
  components: {
    IconBase,
    IconArrowRight
  }
})
export default class A01Heading extends Vue {
  title!: string;
  showButton!: boolean;
  localShowButton = false;

  mounted() {
    this.localShowButton = this.showButton;
    this.evaluateShowButton();
  }

  evaluateShowButton() {
    if (auth.user.displayExchangeButton === false) {
      this.localShowButton = false;
    }
  }

  get isSp(): boolean {
    return globals.isSpScreenWidth;
  }

  get lifeText() {
    return this.isSp ? "Life Service商品" : "Life Service商品を探す";
  }

  get goodsText() {
    return this.isSp ? "Goods商品" : "Goods商品を探す";
  }

  get goodsUrl() {
    return (
      process.env.VUE_APP_IC_DOMAIN +
      CONST_DATA.SITE_MAP.PRODUCT +
      "?selected=goods"
    );
  }

  get lifeUrl() {
    return (
      process.env.VUE_APP_IC_DOMAIN +
      CONST_DATA.SITE_MAP.PRODUCT +
      "?selected=life"
    );
  }
}
</script>

<style lang="scss" scoped>
.c-item-list-heading {
  position: relative;
  .p-a01-heading {
    display: block;
    color: #1f2021;
    font-family: $font--noto-sans-only;
    font-size: rem(36);
    font-weight: 700;
    line-height: 1.25;
    text-align: center;
    font-feature-settings: "pwid" 1, "palt" 1;

    @include sp {
      font-size: rem(24);
    }
  }

  &__button_main {
    display: grid;
    grid-auto-columns: 1fr;
    grid-auto-flow: column;
    align-items: stretch;
    width: fit-content;
    max-width: 100%;
    margin: 0 auto;
    padding-top: rem(40);
    gap: rem(24);

    @include sp {
      width: 100%;
      padding-top: rem(24);
      gap: rem(16);
    }

    :deep(.p-button-main) {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: rem(4);
      width: auto;
      min-width: 0;
      padding: rem(8) rem(12) rem(8) rem(20);
      border-radius: rem(8);
      font-family: $font--noto-sans-only;
      font-size: rem(20);
      font-weight: 700;
      line-height: 1.25;
      font-feature-settings: "pwid" 1, "palt" 1;
      overflow-wrap: anywhere;

      svg {
        flex-shrink: 0;
      }

      @include sp {
        flex: 1 1 0;
        width: 100%;
        min-height: rem(42);
        padding: 0;
        font-size: rem(14);
      }
    }

    &__label {
      display: block;
      flex: 1 1 auto;
      min-width: 0;
      overflow-wrap: anywhere;

      @include sp {
        padding-left: rem(10);
      }
    }
  }
}
</style>
